import React, { useEffect, useState } from "react";
import api from "../../api";
import "bootstrap/dist/css/bootstrap.min.css";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";

const TrainingText = ({}) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedText, setUploadedText] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const LIMIT = 12360; // you can fetch this from API or config if needed

  // ➝ Derived summary values
  const totalChars = uploadedText.reduce(
    (sum, item) => sum + (item.text_content?.length || 0),
    0
  );
  const completion = Math.min(((totalChars / LIMIT) * 100).toFixed(2), 100);

  // ➝ Example: If API gives categories later, you can group dynamically
  // For now, we’ll just show one aggregated summary
  const categorySummary = uploadedText.length
    ? [
        {
          type: "Uploaded Texts",
          value: completion,
        },
      ]
    : [];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!text.trim()) {
      showErrorToast(TOAST_MESSAGES.TEXT_UPLOAD.EMPTY);
      return; // exit before showing "Adding..."
    }

    setIsAdding(true); // Only after validation

    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/upload/text`,
        {
          text,
          title: "User Input Text",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showSuccessToast(TOAST_MESSAGES.TEXT_UPLOAD.SUCCESS);
      setText("");
      fetchTexts();
    } catch (err) {
      console.error("Upload error:", err.response?.data || err.message);
      showErrorToast(TOAST_MESSAGES.TEXT_UPLOAD.ERROR);
    } finally {
      setLoading(false);
      setIsAdding(false);
    }
  };

  useEffect(() => {
    fetchTexts();
  }, []);

  const fetchTexts = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/text`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUploadedText(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch uploaded texts:", err);
      showErrorToast("Error loading uploaded text");
    }
  };

   const handleChangeQAStatus = async (uploadId, currentStatus) => {
      console.log(currentStatus)
      const newStatus = currentStatus == "1" ? "0" : "1";
  
      console.log(uploadId);
  
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/uploaded-files/update_qa_status/${uploadId}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ upload_status: newStatus }),
          }
        );
  
        const result = await response.json();
  
        if (!response.ok) {
          showErrorToast(result.message || "Failed to update status");
          return;
        }
  
        showSuccessToast("Status updated successfully");
  
        // Refresh your QA list
        fetchTexts();
      } catch (err) {
        console.error("Error updating status:", err);
        showErrorToast("Something went wrong");
      }
    };

  return (
    <div
      className="container-fluid mt-2 h-100"
      style={{ paddingBottom: "800px" }}
    >
      <div className="row">
        {/* Upload Form */}
        <div className="col-lg-8">
          <div className="card profile shadow-sm rounded-lg p-4">
            <h5 className="fw-bold mb-3">Text</h5>

            <form onSubmit={handleSubmit}>
              <div className="mb-4" style={{ height: "240px" }}>
                <textarea
                  className="input-textarea1 h-100 border-1"
                  placeholder="Enter text..."
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  style={{
                    border: "dashed var(--input-border-color)",
                  }}
                  disabled={isAdding}   // ✅ disabled while adding
                />
              </div>

              <div className="d-flex gap-3">
                <button
                  type="submit"
                  className="custom-btn flex-fill  w-semibold"
                  disabled={isAdding}
                >
                  {isAdding ? "Uploading..." : "Upload"}
                </button>
              </div>
            </form>
          </div>

          {/* Uploaded Text Table */}
          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "330px", overflowY: "auto" }}
            >
              <table className="table text-center trainingUrls-table align-middle">
                <thead className="text-left">
                  <tr>
                    <th>Text</th>
                    <th>Total Characters</th>
                    <th>Uploaded On</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="text-left">
                  {uploadedText.map((item, index) => (
                    <tr key={index}>
                      <td
                        className="text-truncate"
                        style={{ maxWidth: "300px" }}
                        title={item.text_content}
                      >
                        {item.text_content}
                      </td>
                      
                      <td>{item.text_content?.length || 0}</td>
                      <td>
                        {formatDateToUserTimeZone(new Date(item.created_timestamp))}
                      </td>
                      <td className="text-left">
                          <select
                            className={`badge ${
                              item.upload_status == "1"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                            value={String(item.upload_status)} // ensure string
                            onChange={(e) =>
                              handleChangeQAStatus(item.upload_id, item.upload_status)
                            }
                          >
                            <option value="1">Approved</option>
                            <option value="0">Rejected</option>
                          </select>
                        </td>
                    </tr>
                  ))}
                  {uploadedText.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-muted">
                        There are no text entries found in this section.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Right Summary (Dynamic) */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold mb-4">Summary</h5>
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  className="circle-bg"
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  className="circle"
                  strokeDasharray={`${completion}, 100`}
                  d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#3e3e3e"
                  strokeWidth="2"
                />
              </svg>
              <div className="position-absolute text-center">
                <div className="small">Complete</div>
                <div className="fw-bold fs-2">{completion}%</div>
              </div>
            </div>

            <div className="row text-center mb-4">
              <div className="col">
                <div className="small fw-semibold">Total Characters</div>
                <div className="fw-semibold">{totalChars.toLocaleString()}</div>
              </div>
              <div className="col">
                <div className="small fw-semibold">Limit</div>
                <div className="fw-semibold">{LIMIT.toLocaleString()}</div>
              </div>
            </div>

            {[
              { type: "Translations", value: 80 },
              { type: "Stories", value: 60 },
              { type: "Scripts & Dialogs", value: 40 },
              { type: "Descriptions", value: 50 },
              { type: "Information", value: 70 },
              { type: "FAQs", value: 50 },
            ].map((doc, idx) => (
              <div key={idx} className="mb-3">
                <div className="d-flex justify-content-between small fw-semibold">
                  <span className="text-secondary">{doc.type}</span>
                  {/* <span className="">{doc.value}%</span> */}
                </div>
                <div className="progress" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${doc.value}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingText;
